import React, { useEffect, useRef } from 'react';
import Player from './../player/Player';
import Performances from './../player/Performances';
import NewTracks from './../views/NewTracks';
import navigationStore from './../../stores/navigation';
import { Views } from './../../enums/enums';
import Catalog from './Catalog';
import Search from './Search';
import Favorites from './Favorites';
import Singers from './Singers';
import Home from './Home';
import BackgroundMusic from './BackgroundMusic';
import PlayLists from './PlayLists';
import ContentContainer from '../items/ContentContainer';
import Settings from './Settings';
import Account from './Account';
import Feedback from './Feedback';
import ChangePassword from './ChangePassword';
import ChangeUsername from './ChangeUsername';
import BgPlayer from './BgPlayer';
import BgPlaylists from './BgPlaylists';
import BgSearch from './BgSearch';
import BgStyles from './BgStyles';
import SongbookQueue from './SongbookQueue'
import playerStore from './../../stores/player';

const viewComponentMap = {
  [Views.NewTracks]: NewTracks,
  [Views.Catalog]: Catalog,
  [Views.Search]: Search,
  [Views.Favorites]: Favorites,
  [Views.BackgroundMusic]: BackgroundMusic,
  [Views.Singers]: Singers,
  [Views.PlayLists]: PlayLists,
  [Views.Settings]: Settings,
  [Views.Account]: Account,
  [Views.Feedback]: Feedback,
  [Views.ChangePassword]: ChangePassword,
  [Views.ChangeUsername]: ChangeUsername,
  [Views.BackgroundMusicPlayer]: BgPlayer,
  [Views.BackgroundMusicPlaylists]: BgPlaylists,
  [Views.BackgroundMusicSearch]: BgSearch,
  [Views.BackgroundMusicStyles]: BgStyles,
  [Views.SongbookQueue]: SongbookQueue,
  [Views.Blank]: () => <div></div>,
  [Views.Home]: Home,
};

const bottomBarHeightMinus = 59;

function MobileContainer() {
  const currentView = navigationStore((state) => state.currentView);
  const safeArea = navigationStore((state) => state.safeArea);
  const isSmallVideo = playerStore((state) => state.isSmallVideo);
  const isMobilePlayerVisible = navigationStore((state) => state.isMobilePlayerVisible);

  const containerRef = useRef(null);
  const viewCache = useRef({});

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.className = "muvika-mobile-container";
      containerRef.current.style.paddingTop = "3.75rem !important";
    }
  }, []);

  if (currentView !== Views.Account && currentView !== Views.Settings && !viewCache.current[currentView]) {
    const Component = viewComponentMap[currentView] || Home;
    viewCache.current[currentView] = <Component />;
  }

  const handleTouchMove = (event) => {
    event.stopPropagation();
  };

  const handleTouchStart = (event) => {
    event.preventDefault();
  };

  const renderPlayer = () => (
    <div
      className="muvika-mobile-player"
      style={{
        width: "100%",
        opacity: isMobilePlayerVisible ? 1 : 0,
        position: "absolute",
        left: 0,
        top: safeArea ? "calc("+safeArea.top+"px + 4.6rem)" : "4.5rem",
        zIndex: isMobilePlayerVisible ? 1 : -1,
      }}
    >
      <ContentContainer id="muvika-player-content-container" onScrollDown={() => {
      }} isFinished={true} >
        <Player className="muvika-mobile-player-top" />
        <Performances
          className="muvika-mobile-player-bottom"
          style={{
            paddingRight: safeArea ? `${safeArea.right}px` : 0,
            paddingBottom:"1.3rem",
          }}
        />
      </ContentContainer>
    </div>
  );

  const pxToRem = (px) => {
    const rootFontSize = parseFloat(document.documentElement.style.fontSize);
    return px / rootFontSize;
  }

  const handleResize = () => {
    if (containerRef.current) {
      let containerPos = containerRef.current.getBoundingClientRect().top;
      let height = window.innerHeight - bottomBarHeightMinus - containerPos;
      containerRef.current.style.height = height + 'px';
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', () => {
      handleResize();
    });
  }, []);

  return (
    <div
      ref={containerRef}
      className="muvika-mobile-container"
      style={{
        width: safeArea
          ? `calc(100% - ${safeArea.left + safeArea.right}px)`
          : "100%",
      }}
    >
      {Object.entries(viewCache.current).map(([key, component]) => (
        <div
          key={key}
          style={{ display: key === currentView ? 'block' : 'none' }}
        >
          {component}
        </div>
      ))}

      {currentView === Views.Account && (
        <div style={{ display: 'block' }}>
          <Account />
        </div>
      )}

      {currentView === Views.Settings && (
        <div style={{ display: 'block' }}>
          <Settings />
        </div>
      )}

      {renderPlayer()}
    </div>
  );
};


export default MobileContainer;
